import store from "@/store";

export default [
  {
    path: "/",
    name: "default",
    meta: {
      authRequired: true,
    },
    component: () => import("@/components/pages/dashboard"),
    // redirect: () => {
    //   const properties = store.state.property.properties;
    //   if (properties.length > 0) return { path: `/properties/${properties[0].id}` };
    //   return { path: "/profile" };
    // }
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/components/pages/login"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        if (store.getters["auth/loggedIn"]) {
          // Check if OTP verified or not
          const otpVerified = store.state.auth.otpVerified;
          if (otpVerified) {
            next({ name: "profile" }); // Redirect to profile after OTP verified
          } else {
            next(); // Continue showing OTP verification form
          }
        } else {
          next();
        }
      },
    },
  },
  {
    path: "/profile",
    name: "profile",
    component: () => import("@/components/pages/profile"),
    meta: {
      authRequired: true,
    },
  },
  {
    path: "/forgot-password",
    name: "Forgot password",
    component: () => import("@/components/pages/forgot-password"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/set-password",
    name: "Set password",
    component: () => import("@/components/pages/set-password"),
  },
  {
    path: "/logout",
    name: "logout",
    meta: {
      beforeResolve() {
        store.dispatch("auth/logOut");
      },
    },
  },
  {
    path: "/properties/:id",
    name: "Property",
    component: () => import("@/components/pages/property"),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, _, next) {
        store.dispatch(
          'property/switchProperty',
          { id: routeTo.params.id, callback: () => next() },
          { root: true }
        );
      },
    },
  },
  {
    path: "/properties/:propId/areas/:areaId",
    name: "Area",
    component: () => import("@/components/pages/area"),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, _, next) {
        const callback = () => {
          store.dispatch(
            'area/switchArea',
            { id: routeTo.params.areaId, callback: () => next() },
            { root: true }
          );
        };
        store.dispatch('property/switchProperty', { id: routeTo.params.propId, callback }, { root: true });
      },
    },
  },
  {
    path: "/properties/:propId/areas/:areaId/items/:itemId",
    name: "Item",
    component: () => import("@/components/pages/item"),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, _, next) {
        const areaCallback = () => {
          const itemCallback = () => {
            store.dispatch(
              'item/switchItem',
              { id: routeTo.params.itemId, callback: () => next() },
              { root: true }
            );
          };
          store.dispatch(
            "area/switchArea",
            { id: routeTo.params.areaId, callback: itemCallback },
            { root: true }
          );
        };
        store.dispatch('property/switchProperty', { id: routeTo.params.propId, callback: areaCallback }, { root: true });
      },
    },
  },
  {
    path: "/properties/:propId/category/:category",
    name: "Property Items",
    component: () => import("@/components/pages/category-items"),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, _, next) {
        const areaCallback = () => {
          const categoryCallback = () => {
            const category = routeTo.params.category;
            store.dispatch('item/setCategory', { category }, { root: true })
              .then(next);
          };
          store.dispatch(
            "area/resetArea",
            { callback: categoryCallback },
            { root: true }
          );
        };
        store.dispatch('property/switchProperty', { id: routeTo.params.propId, callback: areaCallback }, { root: true });
      },
    },
  },
  {
    path: "/properties/:propId/areas/:areaId/category/:category",
    name: "Area Items",
    component: () => import("@/components/pages/category-items"),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, _, next) {
        const areaCallback = () => {
          const categoryCallback = () => {
            const category = routeTo.params.category;
            store.dispatch('item/setCategory', { category }, { root: true })
              .then(next);
          };
          store.dispatch(
            "area/switchArea",
            { id: routeTo.params.areaId, callback: categoryCallback },
            { root: true }
          );
        };
        store.dispatch('property/switchProperty', { id: routeTo.params.propId, callback: areaCallback }, { root: true });
      },
    },
  },
  {
    path: "/items/:category?",
    name: "All Items",
    component: () => import("@/components/pages/category-items"),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, _, next) {
        const category = routeTo.params.category;
        store.dispatch('item/setCategory', { category }, { root: true })
          .then(next);
      },
    },
  },
  {
    path: "/orders",
    name: "Orders",
    component: () => import("@/components/pages/order-list"),
    meta: {
      authRequired: true,
      beforeResolve (to, from, next) {
        store.dispatch('order/getOrders', { root: true })
          .then(next);
      },
    },
  },
  {
    path: "/reports/:propertyId",
    name: "Reports",
    component: () => import("@/components/pages/reports"),
    meta: {
      authRequired: true,
    }
  },
  {
    path: "/contact",
    name: "contact",
    component: () => import("@/components/pages/contact"),
    meta: {
      authRequired: true,
    },
  },
  {
    path: "/orders/:id",
    name: "OrderDetail",
    component: () => import("@/components/pages/order-detail"),
    meta: {
      authRequired: true,
      beforeResolve (to, from, next) {
        store.dispatch('order/getOrderById', to.params.id, { root: true })
          .then(next);
      },
    },
  },
  {
    path: "/404",
    name: "404",
    component: require("@/components/pages/utility/404").default,
  },
  {
    path: "/account",
    name: "Account Settings",
    meta: { authRequired: true },
    component: () => import("@/components/pages/account-settings"),
  },
  {
    path: '/reports/:propertyId/item-details',
    name: 'item-details',
    component: () => import("@/components/pages/item-details"),
    props: true
  },
    {
      path: '/reports/:propertyId/item-details',
      name: 'item-details',
      component: () => import("@/components/pages/item-details"),
      props: true
    },
];
